<template>
    <v-dialog v-model="dialog" max-width="680">
        <template #activator="{on}">
            <v-btn v-on="on" class="mr-2" color="accent" outlined >History</v-btn>
        </template>
        <v-card :disabled="loading" :loading="loading">
            <v-card-title>History</v-card-title>
            <v-card-text>
                <div v-for="change in currentPage" class="my-5" :key="'_item_' + change.id">
                    <div class="flex-grow-1 d-flex ">
                        <div class="mr-10">
                            <v-avatar color="accent">
                                <v-icon color="white">mdi-package-variant-closed</v-icon>
                            </v-avatar>
                        </div>
                        <div class="flex-grow-1">
                            <div class="d-flex align-center mb-4">
                                <h3 class="mr-4">{{ change.user.firstname }} {{ change.user.lastname }}</h3>
                                <v-chip outlined color="accent" small>{{ change.type }}</v-chip>
                                <v-spacer></v-spacer>
                                {{ change.created_at | formatDate}}
                            </div>
                            <div class="mb-6">
                                {{ change.change }}
                            </div>
                        </div>
                    </div>
                    <v-divider />
                </div>
                <v-pagination v-if="totalPage > 1" v-model="page" :length="totalPage" />
            </v-card-text>
            <v-card-actions>
                <v-btn outlined @click="dialog = false">Close</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';


export default {
    props: {
        poId:{
            type:Number,
            required:true
        }
    },
    data: () => ({
        changes: [],
        dialog: false,
        page: 1,
        itemsPerPage:5
    }),
    watch: {
        dialog (d) {
            if(d) {
                this.loadData()
            }
        }
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY hh:mm');
        }
    },
    computed: {
        ...mapGetters('purchaseOrders', ['loading']),
        currentPage () {
            return this.changes ? this.changes.slice( this.itemsPerPage * (this.page -1), this.itemsPerPage * (this.page)) : []
        },
        totalPage () {
            return Math.ceil(this.changes.length / this.itemsPerPage)
        }
    },
    methods: {
        ...mapActions("purchaseOrders", ["getChanges"]),
        loadData () {
            this.getChanges({id:this.poId, sort:['-created_at']}).then(({changes}) => {
                this.changes = changes
            })
        }
    }
}
</script>